module.exports = __webpack_public_path__ + "img/portrait-006.b3a1a8f9.jpg";